import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressbarCommunicationService {
  private readonly progressSubject = new Subject<{ error: any; status: string; isGroupUpload: boolean }>();

  public progressStatus$ = this.progressSubject.asObservable();

  public sendProgressStatus(error: any, status: string, isGroupUpload = false): void {
    this.progressSubject.next({ error, status, isGroupUpload });
  }
}
